module.exports = __webpack_public_path__ + "static/media/ashish-basetty.31846ef1.png";